import React, { Component, Fragment } from 'react'
import List2 from './list2'
import { Button, Modal, Table, Col, Row, Dropdown, MenuItem } from 'react-bootstrap'
import { deepValue, getParams, filter, getMonth, end_point, addStatus, makeUniqueKey, validateEmail, getProgramTypeOptions } from './helper'
import HamburgerNavbar from './hamburgerNavbar'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import {faTimes, faInfoCircle, faCopy, faSort, faSortUp, faSortDown} from '@fortawesome/free-solid-svg-icons'
import { CSVLink } from 'react-csv'
import Moment from 'moment'
import SearchBar from './searchBar'
import axios from 'axios'
import { Container } from 'react-bootstrap/lib/Tab'
import ReactTable from "react-table";
import moment from "moment";

var $ = require('jquery');

class Programs2 extends Component {
  linkDropdownRef = React.createRef()

  constructor(props) {
    super(props);
    this.state = {
      allData: [],
      endpoint: this.props.endpoint,
      heading: this.props.heading,
      new: false,
      showModal: false,
      token: getParams().jwt,
      filterableFields: this.props.filterableFields,
      labelFields: this.props.labelFields,
      selectedData: [],
      searchBorder: "dashboard-box",
      selectedItem: null,
      newLink: null,
      showLinkDropdown: false,
      head_coach: {},
      organization_id: localStorage.getItem('organization_id'),
      organization_name: null,
      organization_program_types: [],
      organization_endpoint: `${end_point('organizations')}/organizations`,
      league: false,
      linkHint: false,
      copyLinkHint: false,
      showTransactionExportModal: false,
      transactionExportColumnsLoaded: false,
      selectedTransactionExportColumns: [],
      type: null,
      when: false,
      isSorting: false,
      sortingField: "extras.date_of_birth",
      sortingDirection: ""
    };
  }

    componentDidMount() {
      this.loadPage();
      document.addEventListener('mousedown', this.handleDocumentClick);
      document.body.classList.add('programs-grid-page-active');
      document.documentElement.classList.add('programs-grid-page-active');
    }

    componentWillUnmount() {
      document.removeEventListener('mousedown', this.handleDocumentClick);
      document.body.classList.remove('programs-grid-page-active');
      document.documentElement.classList.remove('programs-grid-page-active');
    }

    handleCloseNewModal() {
      this.setState({ showNewModal: false });
    }

  handleModal = () => {
    if (this.state.when === true) {
      if (window.confirm("You will lose unsaved work.  Leave anyway?")) {
      this.setState({ showModal: false, new: false, league: false, when: false  })
      }
    } else {
      this.setState({ showModal: false, new: false, league: false, when: false  })
    }
  }

  newButtonClicked = (type, league) => {
    var EF2 = league ? true : false
    if (type) {
      this.setState({type})
    }
    this.setState({ showModal: true, new: true, league: EF2});
    this.editorUnclick();
  }

  editClicked = (selectedItem) => {
    this.setState({ selectedItem: this.resolveFamilyModalItem(selectedItem), showModal: true })
    this.editorUnclick();
  }

  resolveFamilyModalItem = (selectedItem) => {
    if (!selectedItem || this.state.heading !== 'Users') {
      return selectedItem
    }

    if ((selectedItem.type === 'athlete' || selectedItem.type === 'secondary') && selectedItem.parent_id) {
      const familyParent = this.state.allData.find((candidate) => {
        return candidate && candidate.type === 'parent' && candidate._id === selectedItem.parent_id
      })

      return familyParent || selectedItem
    }

    return selectedItem
  }

  editorUnclick = () => {
    this.setState({ searchBorder: 'dashboard-box'})
  }

  editorClick = () => {
    this.setState({ searchBorder: 'dashboard-box-orange'})
  }

  handleDocumentClick = (event) => {
    if (
      this.state.showLinkDropdown &&
      this.linkDropdownRef.current &&
      !this.linkDropdownRef.current.contains(event.target)
    ) {
      this.setState({ showLinkDropdown: false, copyLinkHint: false })
    }
  }

  toggleLinkDropdown = () => {
    if (this.state.showLinkDropdown) {
      this.setState({ showLinkDropdown: false, copyLinkHint: false })
      return
    }

    this.setState({
      showLinkDropdown: true,
      newLink: null,
      copyLinkHint: false,
    }, () => {
      this.generateNewLink()
    })
    this.editorUnclick()
  }

  getTransactionExportStorageKey = () => {
    return `transactionExportColumns.${this.state.organization_id}`
  }

  getTransactionExportColumnDefinitions = () => {
    const merch = this.props.organization_merch || []
    const baseColumns = [
      { key: 'record_created', label: 'Record Created', group: 'Transaction Details', value: (ctx) => ctx.recordCreated || '' },
      { key: 'season', label: 'Season', group: 'Transaction Details', value: (ctx) => ctx.season || '' },
      { key: 'program_type', label: 'Program Type', group: 'Transaction Details', value: (ctx) => ctx.programType || '' },
      { key: 'age_group', label: 'Age Group', group: 'Transaction Details', value: (ctx) => ctx.ageGroup || '' },
      { key: 'division', label: 'Division', group: 'Transaction Details', value: (ctx) => ctx.division || '' },
      { key: 'group_name', label: 'Group Name', group: 'Transaction Details', value: (ctx) => ctx.groupName || '' },
      { key: 'parent_first', label: 'Parent First', group: 'People', value: (ctx) => ctx.parentFirst || '' },
      { key: 'parent_last', label: 'Parent Last', group: 'People', value: (ctx) => ctx.parentLast || '' },
      { key: 'parent_phone', label: 'Parent Phone', group: 'People', value: (ctx) => ctx.parentPhone || '' },
      { key: 'parent_email', label: 'Parent Email', group: 'People', value: (ctx) => ctx.parentEmail || '' },
      { key: 'secondary_name', label: 'Secondary Name', group: 'People', value: (ctx) => ctx.secondaryName || '' },
      { key: 'secondary_phone', label: 'Secondary Phone', group: 'People', value: (ctx) => ctx.secondaryPhone || '' },
      { key: 'secondary_email', label: 'Secondary Email', group: 'People', value: (ctx) => ctx.secondaryEmail || '' },
      { key: 'athlete_first', label: 'Athlete First', group: 'People', value: (ctx) => ctx.athleteFirst || '' },
      { key: 'athlete_last', label: 'Athlete Last', group: 'People', value: (ctx) => ctx.athleteLast || '' },
      { key: 'plan_name', label: 'Plan Name', group: 'Billing', value: (ctx) => ctx.planName || '' },
      { key: 'plan_price', label: 'Plan Price', group: 'Billing', value: (ctx) => ctx.planPrice || '' },
      { key: 'additional_fee_label', label: 'Additional Fee', group: 'Billing', value: (ctx) => ctx.additionalFeeLabel || '' },
      { key: 'additional_fee_amount', label: 'Additional Fee Amount', group: 'Billing', value: (ctx) => ctx.additionalFeeAmount || '' },
      { key: 'subtotal', label: 'Subtotal', group: 'Billing', value: (ctx) => ctx.subtotal || '' },
      { key: 'promo_code', label: 'Promo Code', group: 'Billing', value: (ctx) => ctx.promoCode || '' },
      { key: 'promo_code_discount', label: 'Promo Code Discount', group: 'Billing', value: (ctx) => ctx.promoCodeDiscount || '' },
      { key: 'payment_type', label: 'Payment Type', group: 'Payment', value: (ctx) => ctx.paymentType || '' },
      { key: 'payment_status', label: 'Payment Status', group: 'Payment', value: (ctx) => ctx.paymentStatus || '' },
      { key: 'receipt_total', label: 'Receipt Total', group: 'Payment', value: (ctx) => ctx.receiptTotal || '' },
      { key: 'transaction_notes', label: 'Transaction Notes', group: 'Payment', value: (ctx) => ctx.transactionNotes || '' },
    ]

    const merchColumns = merch.map((item, index) => ({
      key: `merch:${index}`,
      label: `${item.name} Cost`,
      group: 'Merchandise',
      value: (ctx) => (ctx.merchCosts[index] || ''),
    }))

    return [...baseColumns, ...merchColumns]
  }

  getDefaultTransactionExportColumns = () => {
    return this.getTransactionExportColumnDefinitions().map((column) => column.key)
  }

  getSelectedTransactionExportColumns = () => {
    const availableKeys = this.getTransactionExportColumnDefinitions().map((column) => column.key)
    if (!this.state.transactionExportColumnsLoaded) {
      return availableKeys
    }
    const selected = this.state.selectedTransactionExportColumns.length
      ? this.state.selectedTransactionExportColumns
      : []
    return selected.filter((column) => availableKeys.includes(column))
  }

  syncTransactionExportColumns = () => {
    const availableKeys = this.getTransactionExportColumnDefinitions().map((column) => column.key)
    const savedSelection = localStorage.getItem(this.getTransactionExportStorageKey())
    let selectedTransactionExportColumns = availableKeys

    if (savedSelection) {
      try {
        const parsedSelection = JSON.parse(savedSelection)
        if (Array.isArray(parsedSelection)) {
          selectedTransactionExportColumns = parsedSelection.filter((column) => availableKeys.includes(column))
        }
      } catch (error) {
        selectedTransactionExportColumns = availableKeys
      }
    }

    this.setState({
      selectedTransactionExportColumns,
      transactionExportColumnsLoaded: true,
    })
  }

  handleTransactionExportModalOpen = () => {
    if (!this.state.transactionExportColumnsLoaded) {
      this.syncTransactionExportColumns()
    }
    this.setState({ showTransactionExportModal: true })
  }

  handleTransactionExportModalClose = () => {
    this.setState({ showTransactionExportModal: false })
  }

  handleTransactionExportColumnToggle = (columnKey) => {
    this.setState((prevState) => {
      const nextColumns = prevState.selectedTransactionExportColumns.includes(columnKey)
        ? prevState.selectedTransactionExportColumns.filter((key) => key !== columnKey)
        : [...prevState.selectedTransactionExportColumns, columnKey]

      localStorage.setItem(this.getTransactionExportStorageKey(), JSON.stringify(nextColumns))
      return { selectedTransactionExportColumns: nextColumns, transactionExportColumnsLoaded: true }
    })
  }

  handleSelectAllTransactionExportColumns = () => {
    const selectedTransactionExportColumns = this.getTransactionExportColumnDefinitions().map((column) => column.key)
    localStorage.setItem(this.getTransactionExportStorageKey(), JSON.stringify(selectedTransactionExportColumns))
    this.setState({ selectedTransactionExportColumns, transactionExportColumnsLoaded: true })
  }

  handleClearTransactionExportColumns = () => {
    localStorage.setItem(this.getTransactionExportStorageKey(), JSON.stringify([]))
    this.setState({ selectedTransactionExportColumns: [], transactionExportColumnsLoaded: true })
  }

  applyTransactionExportPreset = (presetName) => {
    const allColumns = this.getTransactionExportColumnDefinitions()
    const presetMap = {
      minimal: ['record_created', 'season', 'group_name', 'parent_first', 'parent_last', 'athlete_first', 'athlete_last', 'payment_status'],
      parent_contact: ['record_created', 'season', 'program_type', 'age_group', 'group_name', 'parent_first', 'parent_last', 'athlete_first', 'athlete_last', 'parent_phone', 'parent_email', 'secondary_name', 'secondary_phone', 'secondary_email'],
      full: allColumns.map((column) => column.key),
    }

    const selectedTransactionExportColumns = presetMap[presetName] || presetMap.full
    localStorage.setItem(this.getTransactionExportStorageKey(), JSON.stringify(selectedTransactionExportColumns))
    this.setState({ selectedTransactionExportColumns, transactionExportColumnsLoaded: true })
  }

  buildTransactionCSV = () => {
    const definitions = this.getTransactionExportColumnDefinitions()
    const selectedKeys = this.getSelectedTransactionExportColumns()
    const selectedDefinitions = definitions.filter((definition) => selectedKeys.includes(definition.key))
    const csvData = [selectedDefinitions.map((definition) => definition.label)]

    if (!selectedDefinitions.length) {
      return csvData
    }

    this.state.selectedData.forEach((item) => {
      const program = item.program || (item.details && item.details.length ? item.details[0] : {})
      const programs = Array.isArray(item.programs) ? item.programs : []
      const parent = item.parent || item.user || {}
      const athlete = item.athlete || item.user || {}
      const plan = item.plan || (item.plans && Object.keys(item.plans).length ? item.plans[Object.keys(item.plans)[0]] : {})
      const priceBreakdown = item.price_breakdown || {}
      const paymentGateway = item.payment_gateway || {}
      const paymentStatusEntry = Array.isArray(paymentGateway.status) && paymentGateway.status.length ? paymentGateway.status[paymentGateway.status.length - 1] : paymentGateway.status
      const status = paymentStatusEntry && paymentStatusEntry.status ? paymentStatusEntry.status : (typeof paymentGateway.status === 'string' ? paymentGateway.status : '')
      const type = paymentGateway.type && paymentGateway.type.type ? paymentGateway.type.type : ''
      const notes = paymentGateway.notes || ''
      const timestamp = item.create_date ? new Date(item.create_date) : null
      const recordCreated = timestamp
        ? `${getMonth(timestamp.getMonth() + 1)} ${timestamp.getDate()} ${timestamp.getFullYear()} ${Moment(`${timestamp.getHours()}:${timestamp.getMinutes()}`, 'hh:mm').format('hh:mm A')}`
        : ''
      const merchCosts = [
        priceBreakdown.item_0_cost || '',
        priceBreakdown.item_1_cost || '',
        priceBreakdown.item_2_cost || '',
      ]

      const context = {
        recordCreated,
        season: program.season || programs.map((entry) => entry.season).filter(Boolean).join(', '),
        programType: program.type || programs.map((entry) => entry.type).filter(Boolean).join(', '),
        ageGroup: program.ages || programs.map((entry) => entry.ages).filter(Boolean).join(', '),
        division: program.division || programs.map((entry) => entry.division).filter(Boolean).join(', '),
        groupName: program.group_name || programs.map((entry) => entry.group_name).filter(Boolean).join(', '),
        parentFirst: parent.first_name || '',
        parentLast: parent.last_name || '',
        parentPhone: parent.phone || '',
        parentEmail: parent.email || '',
        secondaryName: parent.secondary_name || '',
        secondaryPhone: parent.secondary_phone || '',
        secondaryEmail: parent.secondary_email || '',
        athleteFirst: athlete.first_name || '',
        athleteLast: athlete.last_name || '',
        planName: plan.plan_name || '',
        planPrice: plan.plan_price || '',
        additionalFeeLabel: priceBreakdown.membership_fee ? 'Additional Fee' : '',
        additionalFeeAmount: priceBreakdown.membership_fee || '',
        subtotal: priceBreakdown.plan_price ? (Number(priceBreakdown.plan_price) + Number(priceBreakdown.item_0_cost || 0) + Number(priceBreakdown.item_1_cost || 0) + Number(priceBreakdown.item_2_cost || 0) + Number(priceBreakdown.membership_fee || 0)) : '',
        promoCode: priceBreakdown.promo_code_key || '',
        promoCodeDiscount: priceBreakdown.promo_code || '',
        paymentType: type,
        paymentStatus: status,
        receiptTotal: priceBreakdown.total || '',
        transactionNotes: notes,
        merchCosts,
      }

      const row = selectedDefinitions.map((definition) => `${definition.value(context) || ''}`)
      csvData.push(row)
    })

    return csvData
  }

  loadPage = () => {
    var rthis = this
    if (this.state.heading === 'Programs') {
      $.ajax({
        headers: {
          'token': this.state.token,
          'organization_id': this.state.organization_id,
          'user_type': 'coachadmin'
        },
        method: 'GET',
        dataType: 'json',
        url: `${end_point('users')}/users`,
      }).then(data => this.handleCoach(data.message));

      $.ajax({
        headers: {
          'token': this.state.token,
          'organization_id': this.state.organization_id
        },
        method: 'GET',
        dataType: 'json',
        url: this.state.organization_endpoint,
      }).then(data => {
        this.setState({
          organization_name: data.name,
          organization_program_types: data.program_type_labels ? data.program_type_labels : []
        })
      });
    }
    
    $.ajax({
      headers: {
        'token': this.state.token,
        'organization_id': this.state.organization_id
      },
      method: 'GET',
      dataType: 'json',
      url: this.state.endpoint,
      success: function (data) {
        if (data.errorMessage) {
          alert(data.errorMessage);
        } else {
          console.log('filtered list 2 load page data', data)
          rthis.dataTransform(data)
        }
      },
      error: function (err){
        console.log('error!', err)
        alert('Not authorized');
        window.location.href = document.location.origin + '/portals?jwt=' + rthis.state.token + (rthis.state.organization_id ? ('&organization_id=' + rthis.state.organization_id) : '');
      }
    })
  }

  handleCoach(data) {
    var coach_container = {}
    data.forEach(coach => {
      coach_container[coach['_id']] = `${coach['first_name']} ${coach['last_name']}`
    })
    this.setState({ head_coach: coach_container })
  }

  patchAndReload = (change, id) => {
    console.log('patchAndReload from filteredlisted2', change)
    var rthis = this;
    $.ajax({
      headers: {
        'token': this.state.token,
        'organization_id': localStorage.getItem('organization_id')
      },
      method: 'PATCH',
      contentType: 'application/json',
      data: JSON.stringify({
        'id': id,
        'change': change
      }),
      url: this.state.endpoint,
      success: function (data) {
        if (data.errorMessage) {
          alert(data.errorMessage);
        }
        else {
          rthis.loadPage()
        }
      },
      error: function (data){
        alert('Please try again.')
      }
    })
  }

  updateTransactionStatus = (transaction, status) => {
    const notes = transaction.payment_gateway && transaction.payment_gateway.notes
      ? transaction.payment_gateway.notes
      : ''
    this.patchAndReload({ status, notes }, transaction._id)
  }

  postAndReload = (newDocument) => {
    console.log('postAndReload from filteredlist2', newDocument)
    var rthis = this;
    $.ajax({
      headers: {
        'token': this.state.token,
        'organization_id': localStorage.getItem('organization_id')
      },
      method: 'POST',
      contentType: 'application/json',
      data: JSON.stringify({ 'document': newDocument }),
      url: this.state.endpoint,
      success: function (data) {
        if(data.errorMessage){
          alert(data.errorMessage)
        } else {
          rthis.setState({new: false})
          rthis.loadPage()
        }
      },
      error: function (err) {
        // alert('please contact support')
      }
    })

    // TEMPORARY FIX, This is to fire and forget the request 
    window.setTimeout(() => {
      rthis.setState({new: false})
      rthis.loadPage();  
    }, 3000)
  }

  sort = (data) => {
    const {sortingField, sortingDirection} = this.state;

    const getSortingFieldValueOf = (path, obj) => {
      const pattern  = /(?:\["?)?(\w+)(?:\.|"?])?(.*)/i;
      if(!path) {
        return obj;
      }

      const [full, property, rest] = path.match(pattern);
      return getSortingFieldValueOf(rest, obj[property]);
    }

    if(sortingField?.length > 0 && (sortingDirection === "asc" || sortingDirection === "desc")) {
      return data.sort((item1, item2) => {
        const property1 = getSortingFieldValueOf(sortingField, item1);
        const property2 = getSortingFieldValueOf(sortingField, item2);
        return sortingDirection === "asc" ?
            ('' + property1).localeCompare(property2) :
            ('' + property2).localeCompare(property1);
      })
    } else {
      return data;
    }
  }

  formateDateOfBirth = (item) => {
    if(!!item.extras?.date_of_birth){
      const date_of_birth = new Date(Date.parse(item.extras.date_of_birth));
      const year = date_of_birth.getFullYear();
      const month = date_of_birth.getMonth();
      const monthString = month < 10 ? `0${month}` : month.toString();
      const day = date_of_birth.getDay();
      const dayString = day < 10 ? `0${day}` : day.toString();
      return `${year}/${monthString}/${dayString}`;
    } else {
      return "-";
    }
  }

  formatDates = (data) => {
    const date_columns = ['start_date', 'end_date', 'registration_start_date', 'registration_end_date', 'create_date'];
    data.forEach((item, index) => {
      date_columns.forEach(date_column => {
        if(item[date_column]){
          var date = new Date(item[date_column]);
          data[index][date_column] = moment(date).format('MMM DD, YYYY');
        }
      })
    })
    return data;
  }

  addTransactionFields = (data) => {
    data.forEach((item, index) => {
      var account_holder = item.parent ? `${item.parent.first_name} ${item.parent.last_name}` : '';
      item.account_holder = account_holder;
    });
    return data;
  }

  dataTransform = (data) => {
    if (this.state.heading === 'Programs') {
      var temp_data = addStatus(data)
      this.formatDates(temp_data.message);
      var tempInitialData = this.addSearchField(temp_data.message)
    } else if (this.state.heading === 'Transactions') {
      this.formatDates(data);
      this.addTransactionFields(data);
      tempInitialData = this.addSearchField(data)
    } else if (this.state.heading === 'Users') {
      const parentMap = (data.message || []).reduce((acc, user) => {
        if (user && user.type === 'parent') {
          acc[user._id] = `${user.first_name || ''} ${user.last_name || ''}`.trim()
        }
        return acc
      }, {})
      const secondaryContactMap = (data.message || []).reduce((acc, user) => {
        if (user && user.type === 'parent') {
          const secondaryParent = user.extras && user.extras.secondary_parent ? user.extras.secondary_parent : {}
          acc[user._id] = {
            name: `${secondaryParent.first_name || ''} ${secondaryParent.last_name || ''}`.trim(),
            phone: secondaryParent.phone || '',
          }
        }
        return acc
      }, {})

      data.message.forEach(user => {
        user.extras = user.extras || {};
        user.participant_name = `${user.first_name || ''} ${user.last_name || ''}`.trim();
        user.account_holder = user.type === 'parent'
          ? user.participant_name
          : parentMap[user.parent_id] || '';
        const secondaryContact = user.type === 'parent'
          ? (secondaryContactMap[user._id] || {})
          : (secondaryContactMap[user.parent_id] || {})
        user.secondary_contact_name = secondaryContact.name || `${user.extras.secondary_parent?.first_name || ''} ${user.extras.secondary_parent?.last_name || ''}`.trim();
        user.secondary_contact_phone = secondaryContact.phone || user.extras.secondary_parent?.phone || '';
        user.extras.date_of_birth_formatted = this.formateDateOfBirth(user);
      })
      var tempInitialData = this.addSearchField(data.message)
    } else {
      var info = data.message ? data.message : data
      tempInitialData = this.addSearchField(info)
    }
    this.setState({
      selectedData: filter(tempInitialData).filter((item) => !item || item.type !== 'parent'),
      allData: tempInitialData,
      showModal: false,
      sortingField: "",
      sortingDirection: "",
    }, () => this.setState({
      selectedData: filter(tempInitialData).filter((item) => !item || item.type !== 'parent'),
      allData: tempInitialData,
      sortingField: "",
      sortingDirection: "",
    }))
  }

  addSearchField = (data) => {
    data.forEach((elem, index) => {
      var searchField = '';
      this.state.filterableFields.forEach((objectPath) => {
        if(objectPath === 'head_coach'){
          var field = this.state.head_coach[deepValue(elem, objectPath)];
        } else if (objectPath === 'start_date' || objectPath === 'create_date'){
          var date = new Date(deepValue(elem, objectPath))
          field = `${getMonth(date.getMonth() + 1)} ${date.getDate()}, ${date.getFullYear()}`;
        } else {
          field = deepValue(elem, objectPath);
          if(field && typeof(field)==='string' && field.match(/[àâçéèêëîïôûùüÿñæœ]/)){
            field = this.deplicateAccentCharacters(field)
          }
        }
        if(field === 'approved'){
          searchField = searchField + ' paid'
        } else if (field === 'paid') {
          searchField = searchField + ' paid full'
        } else if (field === 'paidinstal') {
          searchField = searchField + ' paid instal'
        } else if (field) {
          searchField = searchField + ' ' + field;
        }
      })
      if (elem.program) {
        searchField = searchField + ' player'
      } else if (elem.programs) {
        elem.programs.forEach(program => {
          var details = elem.details.find(detail => { return program._id === detail._id })
          searchField = searchField + ` ${program.name} ${program.teams ? program.teams.toString().split(',').join(' ') : ''} ${details ? details.ages: ''} ${elem.plans[program._id] ? elem.plans[program._id].plan_price: ''}`
        })
        searchField = searchField + `${elem.user ? elem.user.first_name : ""} ${elem.user ? elem.user.last_name : ""}` + ' team'
      }
      data[index].searchField = searchField;
    })
    console.log('data', data)
    return data
  }

  deplicateAccentCharacters = (word) =>{
    var new_word = word.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    return `${word} ${new_word}`
  }

  filterList = () => {
    this.setState({
      newLink: null,
      selectedData: filter(this.state.allData).filter((item) => !item || item.type !== 'parent'),
      sortingField: "",
      sortingDirection: ""
    });
  }
  generateNewLink = () => {
    const filterInput = document.getElementsByName('filter')[0]
    var encodeSearch = encodeURIComponent(filterInput ? filterInput.value.toLowerCase() : '')
    var organization_name = encodeURIComponent(this.state.organization_name)
    const isExtLeague = this.state.selectedData.some(item => item.type === "rep league" || item.type === "tournament")
    const link = isExtLeague
      ? `login?organization_id=${this.state.organization_id}&organization_name=${organization_name}&redirectedUser=true&search=${encodeSearch}&extLeague=true`
      : `login?organization_id=${this.state.organization_id}&organization_name=${organization_name}&redirectedUser=true&search=${encodeSearch}`

    this.setState({
      newLink: `${document.location.origin}/${link}`,
      showLinkDropdown: true,
    })
    this.editorUnclick();
  }

  copyAndTell = () => {
    this.setState({ copyLinkHint: !this.state.copyLinkHint });
    navigator.clipboard.writeText(this.state.newLink);
   }

  changeSortCallback = (sortSettings) => {
    this.setState({...sortSettings, isSorting: true}, () => {
      this.setState({
        selectedData: this.sort(filter(this.state.allData)).filter((item) => !item || item.type !== 'parent')
      }, () => {
        this.setState({isSorting: false})
      })
    })
  }

  filterMethod = (filter, row) => {
    const id = filter.pivotId || filter.id;
    if (row[id] !== null && typeof row[id] === "string") {
      return (row[id] !== undefined
        ? String(row[id].toLowerCase()).includes(filter.value.toLowerCase())
        : true)
    } else if (row[id] !== null && typeof row[id] === "number"){
      if (String(row[id]).includes(String(filter.value))) {
        return true
      } else {
        return false
      }
    }
  }

  getColumns = () => {
    switch (this.state.heading) {
      case 'Programs':
        return [
          { Header: "Season", accessor: "season", filterable: true, Placeholder: "Search" },
          { Header: "Ages", accessor: "ages", filterable: true },
          { Header: "Division", accessor: "division", filterable: true, width: 70 },
          { Header: "Group", accessor: "group_name", filterable: true, width: 325 },
          { Header: "Type", accessor: "type", filterable: true },
          { Header: "Status", accessor: "status", filterable: true, width: 70 },
          // { Header: "Enrolled", accessor: "enrollment_total", filterable: true, width: 70 },
          // { Header: "Waitlist", accessor: "enrollment_waitlist", filterable: true, width: 70 },
          // { Header: "Invited", accessor: "enrollment_invited", filterable: true, width: 70 },
          { Header: "Starts", accessor: "start_date", filterable: true },
          { Header: "Ends", accessor: "end_date", filterable: true },
          { Header: "Enrol. Opens", accessor: "registration_start_date", filterable: true },
          { Header: "Enrol. Closes", accessor: "registration_end_date", filterable: true },
          { Header: "Clone", id: "clone", accessor: (row) => this.makeCloneCell(row), filterable: false, width: 92, sortable: false },
        ]
      case 'Plans':
        return [
          { Header: "Plan Name", accessor: "plan_name", filterable: true },
          { Header: "Plan Price", accessor: "plan_price", filterable: true },
        ]
      case 'Transactions':
        return [
          { Header: "Account Holder", accessor: "account_holder", filterable: true },
          { Header: "Participant", accessor: "athlete.first_name", filterable: true },
          { Header: "Group", accessor: "program.ages", filterable: true },
          { Header: "Group Name", accessor: "program.group_name", filterable: true },
          { Header: "Plan Name", accessor: "plan.plan_name", filterable: true },
          { Header: "Total", accessor: "price_breakdown.total", filterable: true },
          { Header: "Status", accessor: "payment_gateway.status.status", filterable: true },
          { Header: "Create Date", accessor: "create_date", filterable: true },
        ]
      case 'Users':
        return [
          { Header: "Participant", accessor: "participant_name", filterable: true },
          { Header: "Account Holder", accessor: "account_holder", filterable: true },
          { Header: "Secondary Contact", accessor: "secondary_contact_name", filterable: true },
          {
            Header: "Type",
            accessor: "type",
            filterable: true,
            Cell: ({ original }) => {
              const badgeClass = original.type === 'parent'
                ? 'users-type-badge users-type-badge-family'
                : original.type === 'athlete'
                  ? 'users-type-badge users-type-badge-participant'
                  : 'users-type-badge users-type-badge-secondary'
              return <span className={badgeClass}>{this.getUserTypeLabel(original.type)}</span>
            }
          },
          { Header: "Archive", id: "archive", accessor: (row) => this.makeArchiveCell(row), filterable: false, width: 110, sortable: false },
        ]
    }
  }

  handleProgramClone = (e, program) => {
    e.stopPropagation();
    e.preventDefault();
    if(window.confirm("Clone this program?")){
      const newDoc = new List2({}).getFields(program);
      this.postAndReload(newDoc);
    }
    return false;
  }

  handleUserArchive = (e, user) => {
    e.stopPropagation();
    e.preventDefault();
    if(window.confirm("Archive this user?")){
      this.patchAndReload({archived: true, email: user.email}, user._id);
    }
    return false;
  }

  makeCloneCell = (row) => (
    <button className="programs-clone-button" onClick={(e) => this.handleProgramClone(e, row)}>
      Clone
    </button>
  );

  makeArchiveCell = (row) => (
    <div className="users-archive-cell">
      <button className="programs-clone-button" onClick={(e) => this.handleUserArchive(e, row)}>
        Archive
      </button>
    </div>
  );

  getUserTypeLabel = (type) => {
    if (type === 'parent') {
      return 'Family'
    }
    if (type === 'athlete') {
      return 'Participant'
    }
    if (type === 'secondary') {
      return 'Secondary'
    }
    return type || ''
  }

  getUserRowClassName = (row) => {
    if (!row || this.state.heading !== 'Users') {
      return ''
    }

    if (row.type === 'parent') {
      return 'users-table-row-family'
    }

    if (row.type === 'athlete') {
      return 'users-table-row-participant'
    }

    if (row.type === 'secondary') {
      return 'users-table-row-secondary'
    }

    return ''
  }

  renderGridActions = () => {
    const { heading, selectedData, token, organization_id } = this.state
    const programTypeOptions = getProgramTypeOptions(this.state.organization_program_types)

    if (heading === 'Transactions') {
      return <Button className="searchbtn programs-action-btn programs-action-btn-neutral" type="button" onClick={this.handleTransactionExportModalOpen} disabled={selectedData.length === 0}>Export</Button>
    }
    if (heading === 'Plans') {
      return <Button className="searchbtn programs-action-btn programs-action-btn-primary" type="button" onClick={this.newButtonClicked}>Create New Plan</Button>
    }
    if (heading === 'Users') {
      return <Button className="searchbtn programs-action-btn programs-action-btn-primary" type="button" onClick={this.newButtonClicked}>Create New User</Button>
    }
    if (heading !== 'Programs') {
      return null
    }

    return (
      <>
        <Dropdown id="create-program-dropdown">
          <Dropdown.Toggle id="dropdown-basic" className="searchbtn programs-action-btn programs-action-btn-primary">
            Create New&nbsp;&nbsp;
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {programTypeOptions.map(option => <MenuItem key={option.key} className="drop-item" onClick={() => this.newButtonClicked(option.value)}>{option.label}</MenuItem>)}
          </Dropdown.Menu>
        </Dropdown>
        <div className="programs-link-dropdown-shell" ref={this.linkDropdownRef}>
          <Button className="searchbtn programs-action-btn programs-action-btn-neutral programs-link-dropdown-toggle" type="button" onClick={this.toggleLinkDropdown}>Get Link</Button>
          {this.state.showLinkDropdown && (
            <div className="programs-link-dropdown-menu">
              <div className="programs-link-modal-copy">Copy the registration link below.</div>
              <div className="programs-link-modal-field">
                <label className="program-link-modal-label" htmlFor="registration-link">Registration Link</label>
                <div className="program-link-inline-field">
                  <input id="registration-link" type="text" className="searchButton" value={this.state.newLink || 'Generating link...'} readOnly />
                  <a className="hint-tip pull-right" onClick={this.copyAndTell}><FontAwesomeIcon icon={faCopy} />{this.state.copyLinkHint && <div className="hint-tip-text" id="name-hint" style={{ marginLeft: '-17em' }}><span>Copied to Clipboard!</span></div>}</a>
                </div>
              </div>
            </div>
          )}
        </div>
        <Dropdown id="preview-program-dropdown">
          <Dropdown.Toggle id="dropdown-basic" className="searchbtn programs-action-btn programs-action-btn-neutral">Preview&nbsp;&nbsp;</Dropdown.Toggle>
          <Dropdown.Menu>
            {(localStorage.parent_email === "rachel@igeno.com" || localStorage.parent_email === "graham@hoopstir.com") && <MenuItem className="drop-item" href={document.location.origin + "/leagueEnrolment?jwt=" + token + '&EF1=true'}>EF1</MenuItem>}
            {programTypeOptions.map(option => <MenuItem key={option.key} className="drop-item" href={document.location.origin + "/enrollmentForm?jwt=" + token + "&organization_id=" + organization_id + `&search=${encodeURIComponent(option.value)}`}>{option.label}</MenuItem>)}
          </Dropdown.Menu>
        </Dropdown>
      </>
    )
  }

  render() {
    const { heading, selectedData, type, token, organization_id } = this.state
    const isTransactions = heading === 'Transactions'
    const isPlans = heading === 'Plans'
    const isUsers = heading === 'Users'
    const isPrograms = heading === 'Programs'
    const isRosters = heading === 'Rosters'
    const modalClassName = this.props.modalClassName || "grid-modal"
    const className = `${this.state.searchBorder} margin-2 search-bar`
    const openCount = (this.state.allData || []).filter((item) => item.status === 'Open').length
    const expiredCount = (this.state.allData || []).filter((item) => item.status === 'Expired').length
    const familyCount = (this.state.allData || []).filter((item) => item.type === 'parent').length
    const athleteCount = (this.state.allData || []).filter((item) => item.type === 'athlete').length
    const programHeaderHelp = 'Create and manage programs. Preview enrolment form displays and create registration links.'
    const programTypeOptions = getProgramTypeOptions(this.state.organization_program_types)
    const transactionDataCSV = heading === 'Transactions' ? this.buildTransactionCSV() : []
    const transactionExportColumns = this.getTransactionExportColumnDefinitions()
    const selectedTransactionExportColumns = this.getSelectedTransactionExportColumns()
    const transactionExportGroups = transactionExportColumns.reduce((groups, column) => {
      if (!groups[column.group]) {
        groups[column.group] = []
      }
      groups[column.group].push(column)
      return groups
    }, {})
    const hasTransactionExportData = transactionDataCSV.length > 1
    
    return (
      <div className="full-page programs-grid-page">
        <HamburgerNavbar />

        <div className="search-page-wrapper programs-page-wrapper">
          <div className={`programs-page-hero ${isTransactions || isPlans || isUsers || isPrograms || isRosters ? 'programs-page-hero-stacked' : ''}`}>
            <div className="programs-page-heading-row">
              <div className="programs-page-copy">
                <div className="programs-page-kicker">Admin Console</div>
                <h2 className="pagetitle programs-page-title">
                  <span>{heading}</span>
                  {isPrograms && (
                    <span className="programs-page-tooltip-trigger" tabIndex="0">
                      <FontAwesomeIcon icon={faInfoCircle} className="programs-page-tooltip-icon" />
                      <span className="programs-page-tooltip">{programHeaderHelp}</span>
                    </span>
                  )}
                </h2>
              </div>
              <div className="programs-page-stats programs-page-stats-inline">
              {isUsers ? (
                <>
                  <div className="programs-stat">
                    <span className="programs-stat-label">Families</span>
                    <span className="programs-stat-value">{familyCount}</span>
                  </div>
                  <div className="programs-stat">
                    <span className="programs-stat-label">Athletes</span>
                    <span className="programs-stat-value">{athleteCount}</span>
                  </div>
                </>
              ) : (
                <>
                  <div className="programs-stat">
                    <span className="programs-stat-label">Open</span>
                    <span className="programs-stat-value">{openCount}</span>
                  </div>
                  <div className="programs-stat">
                    <span className="programs-stat-label">Expired</span>
                    <span className="programs-stat-value">{expiredCount}</span>
                  </div>
                </>
              )}
              </div>
            </div>
            <div className="searchbox-container programs-searchbar programs-page-hero-search">
              <SearchBar className={className} filterList={this.filterList} editorUnclick={this.editorClick} />
              <div className="programs-page-hero-actions">{this.renderGridActions()}</div>
            </div>
            {isTransactions && (
              <div className="programs-page-body">
                <div className="programs-table-scroll transactions-table-scroll">
                  <ReactTable
                    data={selectedData}
                    defaultPageSize={10}
                    pageSize={selectedData.length || 10}
                    showPagination={false}
                    defaultFilterMethod={this.filterMethod}
                    getTrProps={(state, rowInfo) => {
                      return {
                        className: this.getUserRowClassName(rowInfo && rowInfo.original),
                        onClick: () => {
                          if (rowInfo) {
                            this.setState({ selectedItem: this.resolveFamilyModalItem(rowInfo.original), showModal: true })
                            this.editorUnclick();
                          }
                        }
                      }
                    }}
                    columns={this.getColumns()}
                  />
                </div>
              </div>
            )}
            {isPlans && (
              <div className="programs-page-body">
                <div className="programs-grid programs-table-shell programs-plans-shell">
                  <ReactTable
                    data={selectedData}
                    defaultPageSize={10}
                    pageSize={selectedData.length || 10}
                    showPagination={false}
                    defaultFilterMethod={this.filterMethod}
                    getTrProps={(state, rowInfo) => {
                      return {
                        className: this.getUserRowClassName(rowInfo && rowInfo.original),
                        onClick: () => {
                          if (rowInfo) {
                            this.setState({ selectedItem: this.resolveFamilyModalItem(rowInfo.original), showModal: true })
                            this.editorUnclick();
                          }
                        }
                      }
                    }}
                    columns={this.getColumns()}
                  />
                </div>
              </div>
            )}
            {isUsers && (
              <div className="programs-page-body">
                <div className="programs-grid programs-table-shell">
                  <ReactTable
                    data={selectedData}
                    defaultPageSize={10}
                    pageSize={selectedData.length || 10}
                    showPagination={false}
                    defaultFilterMethod={this.filterMethod}
                    getTrProps={(state, rowInfo) => {
                      return {
                        className: this.getUserRowClassName(rowInfo && rowInfo.original),
                        onClick: () => {
                          if (rowInfo) {
                            this.setState({ selectedItem: this.resolveFamilyModalItem(rowInfo.original), showModal: true })
                            this.editorUnclick();
                          }
                        }
                      }
                    }}
                    columns={this.getColumns()}
                  />
                </div>
              </div>
            )}
            {isPrograms && (
              <div className="programs-page-body">
                <div className="programs-grid programs-table-shell">
                  <ReactTable
                    data={selectedData}
                    defaultPageSize={10}
                    pageSize={selectedData.length || 10}
                    showPagination={false}
                    defaultFilterMethod={this.filterMethod}
                    getTrProps={(state, rowInfo) => {
                      return {
                        className: this.getUserRowClassName(rowInfo && rowInfo.original),
                        onClick: () => {
                          if (rowInfo) {
                            this.setState({ selectedItem: this.resolveFamilyModalItem(rowInfo.original), showModal: true })
                            this.editorUnclick();
                          }
                        }
                      }
                    }}
                    columns={this.getColumns()}
                  />
                </div>
              </div>
            )}
            {isRosters && (
              <div className="programs-page-body">
                <div className="programs-grid programs-table-shell programs-rosters-shell">
                  <Table className="tb-grid" style={{ backgroundColor: '#ffffff', color: 'white' }}>
                    <tbody>
                      <tr>
                      {
                        this.state.labelFields.map((field) =>
                          <td style={{borderTop: 'none', width: field.size}} key={makeUniqueKey()}>
                            <ColumnHeader field={field} sortingField={this.state.sortingField} sortingDirection={this.state.sortingDirection} changeSortCallback={this.changeSortCallback} isSorting={this.state.isSorting} />
                          </td>
                        )
                      }
                      </tr>
                    </tbody>
                  </Table>
                  {selectedData?.length > 0 ? (null) : (<div>Loading...</div>)}
                  <List2
                    data={selectedData}
                    labelFields={this.state.labelFields}
                    action={this.editClicked}
                    head_coach={this.state.head_coach}
                    cloneProgram={this.postAndReload}
                    archiveUser={this.patchAndReload}
                    updateTransactionStatus={this.updateTransactionStatus}
                    league={this.state.league}
                    endpoint={this.state.endpoint}
                    allData={this.state.allData}/>
                </div>
              </div>
            )}
          </div>


            {
              !isTransactions && heading === 'Transactions' ? 

            <Row className="searchbox-container programs-searchbar">

              <SearchBar className={className} filterList={this.filterList} editorUnclick={this.editorClick} />

              <Button className="searchbtn programs-action-btn programs-action-btn-neutral" type="button" onClick={this.handleTransactionExportModalOpen} disabled={selectedData.length === 0}>
                Export
              </Button>

              </Row>

              :
                isPlans || isUsers || isPrograms ? "" :
              false ?

              <Row className="searchbox-container programs-searchbar">

                  <SearchBar className={className} filterList={this.filterList} editorUnclick={this.editorClick} />  

                      <Dropdown id="create-program-dropdown">
                        <Dropdown.Toggle id="dropdown-basic" className="searchbtn programs-action-btn programs-action-btn-primary"  style={{marginLeft: "6px"}}>
                          Create New&nbsp;&nbsp;
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          {/*<MenuItem className="drop-item" disabled>--- For Players ---</MenuItem>*/}
                          {
                            programTypeOptions.map(option => <MenuItem key={option.key} className="drop-item" onClick={() => this.newButtonClicked(option.value)}>{option.label}</MenuItem>)
                          }
                          {/*<MenuItem className="drop-item" disabled>--- For Teams ---</MenuItem>*/}
                          {/*{*/}
                          {/*  extLeague_types.map(type => <MenuItem className="drop-item" onClick={() => this.newButtonClicked(type, 'league')}>{capitalize(type)}</MenuItem>)*/}
                          {/*}*/}
                        </Dropdown.Menu>
                      </Dropdown>

                      <div className="programs-link-dropdown-shell" style={{marginLeft: "6px"}} ref={this.linkDropdownRef}>
                        <Button className="searchbtn programs-action-btn programs-action-btn-neutral programs-link-dropdown-toggle" type="button" onClick={this.toggleLinkDropdown}>
                          Get Link
                        </Button>
                        {this.state.showLinkDropdown && (
                          <div className="programs-link-dropdown-menu">
                            <div className="programs-link-modal-copy">
                              Copy the registration link below.
                            </div>
                            <div className="programs-link-modal-field">
                              <label className="program-link-modal-label" htmlFor="registration-link">Registration Link</label>
                              <div className="program-link-inline-field">
                                <input
                                  id="registration-link"
                                  type="text"
                                  className="searchButton"
                                  value={this.state.newLink || 'Generating link...'}
                                  readOnly
                                />
                                <a className="hint-tip pull-right" onClick={this.copyAndTell}>
                                  <FontAwesomeIcon icon={faCopy} />
                                  {
                                    this.state.copyLinkHint &&
                                    <div className="hint-tip-text" id="name-hint" style={{ marginLeft: '-17em' }}>
                                      <span>
                                        Copied to Clipboard!
                                      </span>
                                    </div>
                                  }
                                </a>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>

                      <Dropdown id="create-program-dropdown">
                      <Dropdown.Toggle id="dropdown-basic" className="searchbtn programs-action-btn programs-action-btn-neutral" style={{marginLeft: "6px"}}>
                          Preview&nbsp;&nbsp;
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          {
                            (localStorage.parent_email === "rachel@igeno.com" || localStorage.parent_email === "graham@hoopstir.com") ?
                            <MenuItem className="drop-item" href={document.location.origin + "/leagueEnrolment?jwt=" + token + '&EF1=true'}>EF1</MenuItem>
                            : ""
                          }
                          {
                            programTypeOptions.map(option => <MenuItem key={option.key} className="drop-item" href={document.location.origin + "/enrollmentForm?jwt=" + token + "&organization_id=" + organization_id + `&search=${encodeURIComponent(option.value)}`}>{option.label}</MenuItem>
                            )
                          }
                          {/*{*/}
                          {/*  extLeague_types.map(type => <MenuItem className="drop-item" href={document.location.origin + "/leagueEnrolment?jwt=" + token + `&search=${encodeURIComponent(type)}` + '&extLeague=true'}>{capitalize(type)}</MenuItem>)*/}
                          {/*}*/}
                        </Dropdown.Menu>
                      </Dropdown>
                    
              </Row>

              
              :
              isUsers ?

              <Row className="searchbox-container programs-searchbar">

                  <SearchBar className={className} filterList={this.filterList} editorUnclick={this.editorClick} />               

                  <Button className="searchbtn programs-action-btn programs-action-btn-primary" type="button" style={{marginLeft: "6px"}} onClick={this.newButtonClicked}>Create New User</Button>

              </Row>    

                : ""
            }
          
          <Modal show={this.state.showTransactionExportModal} onHide={this.handleTransactionExportModalClose} dialogClassName="roster-export-modal">
            <Modal.Header closeButton>
              <Modal.Title>Choose export columns</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{maxHeight: '65vh', overflowY: 'auto'}}>
              <p className="roster-export-note">Select the fields to include in the CSV download. Your last selection is remembered for this organization.</p>
              <div className="roster-export-presets">
                <Button type="button" className="programs-action-btn programs-action-btn-neutral" onClick={() => this.applyTransactionExportPreset('minimal')}>Minimal</Button>
                <Button type="button" className="programs-action-btn programs-action-btn-neutral" onClick={() => this.applyTransactionExportPreset('parent_contact')} style={{marginLeft: '8px'}}>Parent Contact</Button>
                <Button type="button" className="programs-action-btn programs-action-btn-neutral" onClick={() => this.applyTransactionExportPreset('full')} style={{marginLeft: '8px'}}>Full Export</Button>
              </div>
              <div className="roster-export-toolbar">
                <Button type="button" className="programs-action-btn programs-action-btn-neutral" onClick={this.handleSelectAllTransactionExportColumns}>Select All</Button>
                <Button type="button" className="programs-action-btn programs-action-btn-neutral" onClick={this.handleClearTransactionExportColumns} style={{marginLeft: '8px'}}>Clear All</Button>
              </div>
              {Object.keys(transactionExportGroups).map((groupName) => (
                <div className="roster-export-group" key={groupName}>
                  <div className="roster-export-group-title">{groupName}</div>
                  <div className="roster-export-grid">
                    {transactionExportGroups[groupName].map((column) => (
                      <label className="roster-export-option" key={column.key}>
                        <input
                          type="checkbox"
                          checked={selectedTransactionExportColumns.includes(column.key)}
                          onChange={() => this.handleTransactionExportColumnToggle(column.key)}
                        />
                        <span>{column.label}</span>
                      </label>
                    ))}
                  </div>
                </div>
              ))}
            </Modal.Body>
            <Modal.Footer>
              <Button type="button" className="programs-action-btn programs-action-btn-neutral" onClick={this.handleTransactionExportModalClose}>Close</Button>
              {hasTransactionExportData ? (
                <CSVLink
                  style={{color: 'white'}}
                  filename={"hoopstir-transactions.csv"}
                  target="_self"
                  data={transactionDataCSV}
                  onClick={this.handleTransactionExportModalClose}
                >
                  <Button className="searchbtn programs-action-btn programs-action-btn-neutral" type="button">Download CSV</Button>
                </CSVLink>
              ) : (
                <Button className="searchbtn programs-action-btn programs-action-btn-neutral" type="button" disabled={true}>Download CSV</Button>
              )}
            </Modal.Footer>
          </Modal>
          {isTransactions || isPlans || isUsers || isPrograms || isRosters ? null : this.props.heading !== 'Rosters' ? (
            <div className="programs-grid programs-table-shell">
              <ReactTable
                data={selectedData}
                defaultPageSize={10}
                pageSize={selectedData.length || 10}
                showPagination={false}
                defaultFilterMethod={this.filterMethod}
                getTrProps={(state, rowInfo) => {
                  return {
                    className: this.getUserRowClassName(rowInfo && rowInfo.original),
                    onClick: () => {
                      if (rowInfo) {
                        this.setState({ selectedItem: this.resolveFamilyModalItem(rowInfo.original), showModal: true })
                        this.editorUnclick();
                      }
                    }
                  }
                }}
                columns={this.getColumns()}
                 />
            </div>
          ) : (
            <div className="datagrid">
              <Table className="tb-grid" style={{ backgroundColor: '#ffffff', color: 'white' }}>
                <tbody>
                  <tr>
                  {
                    this.state.labelFields.map((field) =>
                      <td style={{borderTop: 'none', width: field.size}} key={makeUniqueKey()}>
                        <ColumnHeader field={field} sortingField={this.state.sortingField} sortingDirection={this.state.sortingDirection} changeSortCallback={this.changeSortCallback} isSorting={this.state.isSorting} />
                      </td>
                    )
                  }
                  </tr>
                </tbody>
              </Table>
              {selectedData?.length > 0 ? (null) : (<div>Loading...</div>)}
              <List2
                data={selectedData}
                labelFields={this.state.labelFields}
                action={this.editClicked}
                head_coach={this.state.head_coach}
                cloneProgram={this.postAndReload}
                    archiveUser={this.patchAndReload}
                    updateTransactionStatus={this.updateTransactionStatus}
                    league={this.state.league}
                endpoint={this.state.endpoint}
                allData={this.state.allData}/>
          </div>)}

          <Modal dialogClassName={modalClassName} show={this.state.showModal} onHide={this.handleModal} enforceFocus={false}>
            <Modal.Body>
              <Row>
                <Col sm={2} className="pull-right" style={{textAlign: 'right'}}>
                  <a className="program-modal-close" onClick={this.handleModal}>
                    <FontAwesomeIcon icon={faTimes} size="1x" color='white' />
                  </a>
                </Col>
              </Row>
              { this.state.new ? (React.cloneElement(this.props.children,
                {
                  mode: 'new',
                  postMethod: this.postAndReload,
                  handleCloseModalNew: this.handleModal,
                  league: this.state.league,
                  type: type,
                  setWhenDirty: (dirty) => this.setState({ when: dirty })
                }
              )) : (React.cloneElement(this.props.children,
                {
                  mode: 'edit',
                  selectedItem: this.state.selectedItem,
                  patchUpdateMethod: this.patchAndReload,
                  handleCloseModalEdit: this.handleModal,
                  loadPage: this.loadPage,
                  league: this.state.league,
                  setWhenDirty: (dirty) => this.setState({ when: dirty })
                }
              ))}
              <div> &nbsp;</div>
            </Modal.Body>
          </Modal>

          </div>
      </div>
    )
  }

}

function ColumnHeader(props) {
  if(props.field.sortable) {
    return <SortableColumnHeader {...props} />
  } else {
    return <span>{props.field.displayName}</span>
  }
}

function SortableColumnHeader(props) {
  function updateSort() {
    const sortingField = props.field.name;
    let sortingDirection = "asc";
    if(sortingField === props.sortingField) {
      if(props.sortingDirection === "asc") {
        sortingDirection = "desc";
      } else if(props.sortingDirection === "desc") {
        sortingDirection = "";
      }
    }
    props.changeSortCallback({sortingDirection, sortingField});
  }

  return (
      <button style={{backgroundColor: "transparent", border: "none"}} onClick={updateSort} disabled={props.isSorting}>
        <span>{props.field.displayName}</span>
        {props.isSorting ? (
            <span>...</span>
        ): <SortIcon {...props} />}
      </button>
  )
}

function SortIcon({field, sortingField, sortingDirection}) {
  let icon = faSort;
  if(field.name === sortingField) {
    if(sortingDirection === "asc") {
      icon = faSortUp;
    } else if(sortingDirection === "desc") {
      icon = faSortDown;
    }
  }
  return <span style={{marginLeft: "3px"}}><FontAwesomeIcon icon={icon} size={"1x"} color={"white"}></FontAwesomeIcon></span>
}

export default Programs2;
